// extracted by mini-css-extract-plugin
export default {"editForm":"EditChild_editForm__TKjS7","closeButton":"EditChild_closeButton__GqFA5","editButtons":"EditChild_editButtons__L+0vc"};